import { Box } from 'components/Box';
import { RichTextHeadline } from 'components/Text/RichTextHeadline';
import { CmsApiCategoryHighlightBlockData } from 'modules/cms/api/types/CmsApiCategoryHighlight';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { gutterWidth } from 'theme';

import { CmsCategoryHighlightBlockCategory } from './CmsCategoryHighlightBlockCategory';

type Props = {
  content: CmsApiPage;
  data: CmsApiCategoryHighlightBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsCategoryHighlightBlock({
  content,
  data: { headline, categories },
  blockIndex,
  pageUpdated,
}: Props) {
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  const homePageUrl = content.subsite.homePage && content.subsite.homePage.url;

  return (
    <Box data-qa-id="cms-category-highlight">
      {headline && (
        <RichTextHeadline
          textAlign={['left', 'center']}
          mb={[gutterWidth / 2, null, null, gutterWidth * 1.5]}
        >
          {headline}
        </RichTextHeadline>
      )}

      <Box
        m={[-gutterWidth / 4, null, -gutterWidth / 2]}
        display="flex"
        flexWrap="wrap"
      >
        {categories.map((category, index) => (
          <CmsCategoryHighlightBlockCategory
            category={category}
            homePageUrl={homePageUrl}
            key={`${category.name}-${index}`} // eslint-disable-line react/no-array-index-key
            blockIndex={blockIndex}
            pageUpdated={pageUpdated}
          />
        ))}
      </Box>
    </Box>
  );
}
